// /your-step Royalty < Seller < Provider hierarchy (spec §1-3): pure,
// dependency-free helpers so the Become-vs-Cancel decision lives in exactly
// one place instead of being duplicated across userStep.js's three
// sections. Kept in its own module (rather than inline in userStep.js) so
// it can be unit-tested without pulling in userStep.js's own heavy import
// graph (Layout/Swiper/...).
//
// Mirrors server_elakay's ROLE_CONFIG levels
// (elakay_services/roleActivation.js: Royalty=1, Seller=2, Provider=3) --
// keep both in sync if this hierarchy ever changes.
export const LEVEL_MAP = {
  royalty: 1,
  seller: 2,
  provider: 3
};

export const normalizeRoleId = (roleName) => {
  const normalized = String(roleName || "").trim().toLowerCase();
  return LEVEL_MAP[normalized] ? normalized : null;
};

export const getRoleLevel = (roleId) => LEVEL_MAP[roleId] || 0;

// true => the target plan must show "Cancel <current role>" instead of
// "Become <plan>" (target level <= current level, and the account actually
// holds one of the three hierarchy roles). false covers both a real
// upgrade AND an account outside this hierarchy entirely (simple user,
// Associate, Family, ...), which the existing Become workflow keeps
// handling untouched (spec §18).
export const shouldShowCancelInstead = (currentRoleName, targetPlanId) => {
  const currentRoleId = normalizeRoleId(currentRoleName);
  if (!currentRoleId) return false;
  return getRoleLevel(targetPlanId) <= getRoleLevel(currentRoleId);
};
